// extracted by mini-css-extract-plugin
export default {"card":"Item_card__h3e8D","card-header":"Item_card-header__kxdaK","card-body":"Item_card-body__uho2U","item-price":"Item_item-price__Hn7tj","cartBtn":"Item_cartBtn__u+T0o"};